<template>
  <div>
    <vx-card>
      <ListGrupos :subjectPermission="subjectPermission"></ListGrupos>
    </vx-card>
  </div>
</template>

<script>
import ListGrupos from "./../../lists/ListGrupos";

export default {
  data() {
    return {
      subjectPermission: "Grupo de Veículos",
    };
  },
  methods: {},
  components: {
    ListGrupos,
  },
};
</script>
